import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './App';
import {CssBaseline, ThemeProvider, createMuiTheme} from '@material-ui/core';
import {initializeIcons} from '@fluentui/react';
import CacheBuster from 'components/CacheBuster';

initializeIcons();

const defaultPalette = {
  primary: {
    main: '#2a9d7c',
  },
  secondary: {
    main: '#e9faec'
  },
  error: {
    main: '#f44336',
    light: '#fdecea'
  },
  yellow: '#fc0',
  green: '#2a9d7c',
  red: '#f44336',
  text:
  {
    primary: '#666',
    secondary: '#333'
  },
  background:
  {
    default: '#f2f4f6',
    paper: '#fff'
  },
  input:
  {
    foreground: '#333',
    background: '#f2f4f6',
    placeholder: '#666'
  }
}


function buildTheme(palette)
{
  return {
    props:
    {
      MuiLink:
      {
        underline: "none"
      }
    },
    overrides:
    {
      // MuiCssBaseline: {
      //   '@global': {
      //     '*::-webkit-scrollbar': {
      //       width: 10
      //     },
      //     '*::-webkit-scrollbar-thumb': {
      //       backgroundColor: palette.primary.main,
      //       borderRadius: 10,
      //       border: 'solid 2px transparent'
      //     }
      //   }
      // },
      MuiTypography: {
        body1: {
          fontSize: undefined,
          lineHeight: 1
        }
      },
      MuiPaper:
      {
        rounded:
        {
          borderRadius: 16
        }
      },
      MuiButton:
      {
        containedSecondary:
        {
          color: palette.primary.main
        }
      },
      MuiAlert:
      {
        root:
        {
          borderRadius: 16
        }
      },
      MuiDataGrid:
      {
        root:
        {
          borderLeft: "none",
          borderRight: "none",
          borderRadius: 0,
          '& .MuiDataGrid-cellRight':
          {
            justifyContent: 'flex-end'
          },
          '& .MuiDataGrid-cellCenter':
          {
            justifyContent: 'center'
          },
          '& .MuiDataGrid-cell:focus':
          {
            outline: "none"
          },
          '& .MuiDataGrid-colCell:focus':
          {
            outline: "none"
          },
          '& .MuiDataGrid-columnSeparator':
          {
            display: "none"
          },
          '& .MuiDataGrid-row':
          {
            '&:hover':
            {
              backgroundColor: palette.input.background
            },
            '&.Mui-selected':
            {
              backgroundColor: palette.input.background,
              '&:hover':
              {
                backgroundColor: palette.input.background
              }

            }
          }
        },
        
      },
      MuiCheckbox:
      {
        root:
        {
          color: palette.text.primary
        }
      }
    },
  
    palette: palette,
    typography:
    {
      login:
      {
        color: palette.text.primary,
        fontSize: 13,
        fontWeight: 500
      }
    }
  }
}

// const theme = createMuiTheme(buildTheme(paletteLight));

function ThemeLoader(props)
{
  const [theme, setTheme] = React.useState(null);

  React.useEffect(function loadTheme(){
    fetch('./skins/default.json').then((response) =>
    {
      if(response.ok)
      {
        response.json().then((palette) => setTheme(createMuiTheme(buildTheme({...defaultPalette, ...palette})))).catch(() => setTheme(createMuiTheme(buildTheme(defaultPalette))));
      }
      else
      {
        setTheme(createMuiTheme(buildTheme(defaultPalette)));
      }
    });
  }, []);

  if(!theme) return null;
  else return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
}

ReactDOM.render(
  // <React.StrictMode>
    <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return (
            <ThemeLoader>
              <CssBaseline />
              <App/>
            </ThemeLoader>
          );
        }}
      </CacheBuster>
  // </React.StrictMode>,
  , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

